<template>
	<v-modal class="v-message" ref="message">
		<div class="v-message-icon" :type="type">
			<v-icon :type="`v-icon-message-${type}`"/>
		</div>
		<div class="v-message-content">
			<slot/>
		</div>
		<div class="v-message-close" @click="close">
			<slot name="close" v-if="'close' in $slots"/>
			<v-icon type="v-icon-message-close" v-else-if="$attrs.closable!=null"/>
		</div>
	</v-modal>
</template>

<script>
export default {
  props: {
    type: {
      default: "info"
    }
  },
  methods: {
    open() {
      this.$refs.message.open();
    },
    close() {
      this.$refs.message.close();
    }
  }
};
</script>

<style lang="less">
.v-modals > .v-modal.v-message {
  padding: 0px;
  position: initial;
  margin: 10px 10px 0px 10px;
  transform: translate3d(0, 0, 0);
  > .v-modal-body {
    overflow: hidden;
    min-width: 150px;
    line-height: 32px;
    display: inline-flex;
    > .v-message-icon {
      width: 32px;
      color: #ffffff;
      text-align: center;
      &[type="info"] {
        background-color: #1890ff;
      }
      &[type="warn"] {
        background-color: #fa8c16;
      }
      &[type="error"] {
        background-color: #f5222d;
      }
      &[type="success"] {
        background-color: #52c41a;
      }
    }
    > .v-message-content {
      flex: 1;
      padding: 0px 10px;
    }
    > .v-message-close {
      width: 32px;
      cursor: pointer;
      color: #999999;
      text-align: center;
    }
    > .v-message-close:empty {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/modal/message.vue